import {SET_NOTIFICATIONS, 
        ADD_NOTIFICATION, 
        ADD_NOTIFICATIONS,
        SET_CATEGORIES,
        ADD_CATEGORY,
        ADD_CATEGORIES} from 'actions/types';

var notificationsInitialState = {list:[], indexed:{}, listLoaded:false};
export default (state = notificationsInitialState, action) => {
    switch(action.type) {
        case SET_NOTIFICATIONS: 
            return {...state,
                    list:action.notifications.map((c)=>(c.id)),
                    indexed: action.notifications.reduce((m,c)=>{m[c.id]=c;return m;},{...state.indexed}),
                    listLoaded:true
                    };
        case ADD_NOTIFICATION: 
            return {...state,
                    indexed: {...state.indexed, [action.notification.id]:action.notification}
                    };
        case ADD_NOTIFICATIONS: 
            return {...state,
                    indexed: action.notifications.reduce((m,c)=>{m[c.id]=c;return m;},{...state.indexed})
                    };


        //normalize categories
        case SET_CATEGORIES: //fallthrough
        case ADD_CATEGORIES: 
            return {...state,
                    indexed: action.categories.map(c=>c.notifications)
                                              .reduce((m,notifications)=>{
                                                            if(notifications!==undefined && notifications!==null) {
                                                                notifications.forEach(notification => m[notification.id]=notification);
                                                            }
                                                            return m;}
                                                      ,{...state.indexed})
                    };
        case ADD_CATEGORY: 
            return {...state,
                    indexed: (action.category.notifications||[]).reduce((m,c)=>{m[c.id]=c;return m;},{...state.indexed})
                    };
        default:            
            return state;
    }
}

export const isListLoaded = state => state.listLoaded;
export const getNotifications = state => state.list.map( id => state.indexed[id] );
export const getNotification  = (state, id) => state.indexed[id];
export const getNotificationsByCategoryId = (state, categoryId) => Object.values(state.indexed).filter(notification => notification.categoryId===categoryId);



// WEBPACK FOOTER //
// ./src/reducers/notifications.js